import { BubbleChartAxisProps, TickMarkProps } from './types';
import { AxisLine, AxisTick, AxisTitle, YAxisLabel } from './atoms';
import { memo } from 'react';

const TickMarkY = ({
  transform,
  gridLineLength,
  tickLabel,
  labelOffset,
}: TickMarkProps) => (
  <g transform={transform}>
    <AxisTick x2={gridLineLength} />
    <YAxisLabel x={labelOffset} dy=".32em">
      {tickLabel}
    </YAxisLabel>
  </g>
);

export const YAxis = memo(
  ({
    title,
    axisTransform,
    axisLinePath,
    tickProps,
    axisTitleProps,
  }: BubbleChartAxisProps) => (
    <g transform={axisTransform}>
      {tickProps.map(props => (
        <TickMarkY key={props.tickLabel} {...props} />
      ))}
      <AxisLine d={axisLinePath} />
      <AxisTitle {...axisTitleProps}>{title}</AxisTitle>
    </g>
  )
);
